import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import redirectURL from "../redirectURL";
import Loader from '../mainpage/Loader';

const CommentModal = (props) => {

    const [comment, setComment] = useState('')
    const [loader, setLoader] = useState(false)

    const closeCommentModal = () => {
        props?.setCommentModal(false)
    }
    const formCommentHandler = async (e) => {
        e.preventDefault()
        let reqdata = {
            fo_number: props?.consignment.fo_number,
            consignment_code: props?.consignment.consignment_code,
            truck_no: props?.consignment.truck_no,
            consignee_code: props?.consignment.consignee_code,
            consignee_name: props?.consignment.consignee_name,
            email: props?.user?.email,
            comment: comment,
        }
        setLoader(true)
        await redirectURL.post("/consignments/saveComment", reqdata)
            .then((response) => {
                if (response.data.status == 'success') {
                    setLoader(false)
                    props?.setShow(true)
                    setComment('')
                    props?.setTitle("Comment Saved")
                    props?.setType("success")
                    props?.setCommentModal(false)
                    props?.setRownode('')
                    props?.loadData()
                }
                else {
                    setLoader(false)
                    props?.setShow(true)
                    props?.setTitle("Failed to Save Comment")
                    props?.setType("danger")
                }
            })
            .catch(function (e) {
                console.log("Error ", e)
            })
    }

    return (
        <div>
            <Loader show={loader} />
            <Modal
                onHide={closeCommentModal}
                dialogClassName="my-modal"
                show={props?.commentModal}
                centered>
                <Modal.Header>
                    <Modal.Title>Comment</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeCommentModal}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="view-task">
                    <form onSubmit={formCommentHandler}>
                        <div className="col-xl-12 col-lg-12">
                            <label style={{ color: "#EB1D54", fontSize: "13px", fontFamily: "Inter" }}>*</label>
                            <label className="custom-label">
                                Comment
                            </label>
                            <textarea
                                type="text"
                                value={comment}
                                onChange={e => setComment(e.target.value)}
                                autoComplete="off"
                                className="form-control"
                                required
                            />
                        </div>
                        <div style={{ paddingTop: "2rem", display: "flex", justifyContent: "flex-end" }}>
                            <button type='submit' className='primary-button'>Submit</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    )
}
export default CommentModal